module.exports = __webpack_public_path__ + "img/paved.0ec89a7b.png";